import { Grid, List, Menu, styled } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import Button from "../../../../components/Form/Button";

export const FilterButton = styled(Button)(() => ({
  backgroundColor: "#308CDB",
  borderRadius: "8px",
  height: "40px",
  padding: "10px",
  "& .MuiButton-startIcon": {
    marginLeft: 0,
  },
  "&:hover": {
    backgroundColor: "#369CF3",
  },
  "&:active": {
    backgroundColor: "#03569E",
  },
}));

export const TextButton = styled("span")(() => ({
  fontFamily: "Inter",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "15px",
  color: "#FFFFFF",
  fontStyle: "normal",
}));

export const MenuFilter = styled(Menu)(() => ({
  marginTop: "45px",
}));

export const ListContainer = styled(List)(() => ({
  paddingBottom: "16px",
}));

export const TextHeader = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "28px",
  color: "#344054",
}));

export const FilterHeader = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: "16px 16px 0 16px",
}));

export const ListItem = styled("li")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 .5rem",
  "& span": {
    font: "500 14px/21px Manrope",
    color: "#465869",
    "&:first-of-type": {
      fontWeight: 700,
      color: "#308CDB",
    },
  },
}));

export const IconCountFilter = styled("div")(() => ({
  backgroundColor: "#FFFFFF",
  color: "#03569E",
  position: "absolute",
  zIndex: 100,
  top: "1px",
  right: "1px",
  borderRadius: "50%",
  padding: "1px",
  width: "20px",
  height: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const useStyles = makeStyles(() => ({
  menuFilter: {
    minWidth: "200px",
  },
}));
